import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useCreateStandardParagraphMutation } from "../../../services/clientreports";
import _ from "lodash";

const defaultValues = {
    typeId: null,
    name: ""
}

const useCreateStandardParagraph = (onHide) => {
    const [fileData, setFileData] = useState(null);

    const onFileClear = () => setFileData(null);

    const onFileDrop = async (acceptedFiles) => setFileData(acceptedFiles?.[0]);

    const buildFormData = (data) => {
        const formData = new FormData();

        formData.append('attachment', fileData, fileData.name);
        Object.keys(data).forEach(key => {
            formData.append(key, data[key]);
        });

        return formData;
    }

    const [createTrigger, { isLoading: isCreating, ...createResult }] = useCreateStandardParagraphMutation();

    const form = useForm({ defaultValues });
    const { setValue, handleSubmit, reset, watch } = form;

    const onClose = () => {
        reset(defaultValues);
        setFileData(null);
        onHide();
    }

    const onCreate = (data) => {
        onClose();
        const { name } = data;
        const formData = buildFormData(data);
        return toast.promise(createTrigger(formData).unwrap(), {
            loading: `Creating Standard Paragraph '${name}'`,
            success: `Created Standard Paragraph '${name}'`,
            error: `Failed to create Standard Paragraph '${name}'`
        })
    }

    // Update name on file upload if no name provided
    useEffect(() => {
        if (fileData?.name == null)
            return;

        if (_.isEmpty(watch('name')))
            setValue('name', fileData.name.replace(/\.[^/.]+$/, ""))
    }, [fileData, setValue, watch]);

    return {
        onFileClear,
        onFileDrop,
        fileData,
        onClose,
        onSubmit: handleSubmit(onCreate),
        ...form,
        isCreating,
        ...createResult
    }
}

export default useCreateStandardParagraph;